import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadTOHerstellerListStatus: 'idle',
    loadTOHerstellerListError: undefined as any,
    loadTOHerstellerListLastArgs: undefined as any,
    loadTOHerstellerStatus: 'idle',
    loadTOHerstellerError: undefined as any,
    saveTOHerstellerStatus: 'idle',
    saveTOHerstellerError: undefined as any,
    deleteTOHerstellerStatus: 'idle',
    deleteTOHerstellerError: undefined as any,

    toHerstellerList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadTOHerstellerList = createAsyncThunk('toHerstellerSlice/loadTOHerstellerList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toHerstellerSlice.loadTOHerstellerListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristoherst/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOHerstellerListStatus } = getState().toHerstellerSlice
        return loadTOHerstellerListStatus !== 'pending'
    }
})

export const loadTOHersteller = createAsyncThunk('toHerstellerSlice/loadTOHersteller', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristoherst/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOHerstellerStatus } = getState().toHerstellerSlice
        return loadTOHerstellerStatus !== 'pending'
    }
})

export const saveTOHersteller = createAsyncThunk('toHerstellerSlice/saveTOHersteller', async ({ toHersteller }: any, { rejectWithValue }: any) => {
    let promises = []
    if (toHersteller?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nuristoherst/${ toHersteller?.HDR_ID }/`,
            prepareData(toHersteller),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nuristoherst/`,
            prepareData(toHersteller),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveTOHerstellerStatus } = getState().toHerstellerSlice
        return saveTOHerstellerStatus !== 'pending'
    }
})

export const deleteTOHersteller = createAsyncThunk('toHerstellerSlice/deleteTOHersteller', async ({ selectedIds }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/DeleteTOHersteller/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: selectedIds.HDR_ID,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteTOHerstellerStatus } = getState().toHerstellerSlice
        return deleteTOHerstellerStatus !== 'pending'
    }
})

const ToHerstellerSlice = createSlice({
    name: 'toHerstellerSlice',
    initialState,
    reducers: {
        resetloadTOHerstellerListError: (state) => {
            state.loadTOHerstellerListError = undefined
        },
        resetloadTOHersteller: (state) => {
            state.formItem = undefined
            state.loadTOHerstellerError = undefined
        },
        resetloadTOHerstellerError: (state) => {
            state.loadTOHerstellerError = undefined
        },
        resetsaveTOHersteller: (state) => {
            state.formItem = undefined
            state.saveTOHerstellerError = undefined
        },
        resetsaveTOHerstellerError: (state) => {
            state.saveTOHerstellerError = undefined
        },
        resetdeleteTOHerstellerError: (state) => {
            state.deleteTOHerstellerError = undefined
        },
        removeFromToHerstellerListById: (state, action) => {
            state.toHerstellerList = state.toHerstellerList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromToHerstellerListByIds: (state, action) => {
            state.toHerstellerList = state.toHerstellerList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.toHerstellerList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadTOHerstellerListStatus = 'preloaded'
            state.loadTOHerstellerListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.toHerstellerList = []
            state.loadTOHerstellerListStatus = 'idle'
            state.loadTOHerstellerListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadTOHerstellerList.pending, (state) => {
            state.loadTOHerstellerListStatus = 'pending'
            state.loadTOHerstellerListError = undefined
        })
        builder.addCase(loadTOHerstellerList.fulfilled, (state, action) => {
            state.loadTOHerstellerListStatus = 'idle'

            if (!action.payload) { return }

            state.loadTOHerstellerListLastArgs = action.payload.args

            {
                state.toHerstellerList = action.payload.data

            }
        })
        builder.addCase(loadTOHerstellerList.rejected, (state, action) => {
            state.loadTOHerstellerListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOHerstellerListError = action.error.message
            } else {
                state.loadTOHerstellerListError = action.payload
            }
        })

        builder.addCase(loadTOHersteller.pending, (state) => {
            state.loadTOHerstellerStatus = 'pending'
            state.loadTOHerstellerError = undefined
        })
        builder.addCase(loadTOHersteller.fulfilled, (state, action) => {
            state.loadTOHerstellerStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.toHerstellerList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.toHerstellerList.push(newItem) }
                else { state.toHerstellerList[i] = { ...state.toHerstellerList[i], ...newItem } }
            }
        })
        builder.addCase(loadTOHersteller.rejected, (state, action) => {
            state.loadTOHerstellerStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOHerstellerError = action.error.message
            } else {
                state.loadTOHerstellerError = action.payload
            }
        })

        builder.addCase(saveTOHersteller.pending, (state) => {
            state.saveTOHerstellerStatus = 'pending'
            state.saveTOHerstellerError = undefined
        })
        builder.addCase(saveTOHersteller.fulfilled, (state, action) => {
            state.saveTOHerstellerStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.toHerstellerList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.toHerstellerList.push(newItem) }
                else { state.toHerstellerList[i] = { ...state.toHerstellerList[i], ...newItem } }
            }
        })
        builder.addCase(saveTOHersteller.rejected, (state, action) => {
            state.saveTOHerstellerStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveTOHerstellerError = action.error.message
            } else {
                state.saveTOHerstellerError = action.payload
            }
        })

        builder.addCase(deleteTOHersteller.pending, (state) => {
            state.deleteTOHerstellerStatus = 'pending'
            state.deleteTOHerstellerError = undefined
        })
        builder.addCase(deleteTOHersteller.fulfilled, (state, action) => {
            state.deleteTOHerstellerStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.toHerstellerList = state.toHerstellerList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.toHerstellerList = state.toHerstellerList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteTOHersteller.rejected, (state, action) => {
            state.deleteTOHerstellerStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteTOHerstellerError = action.error.message
            } else {
                state.deleteTOHerstellerError = action.payload
            }
        })

    }
})

export const {
    resetloadTOHerstellerListError,
    resetloadTOHersteller,
    resetloadTOHerstellerError,
    resetsaveTOHersteller,
    resetsaveTOHerstellerError,
    resetdeleteTOHerstellerError,
    removeFromToHerstellerListById,
    removeFromToHerstellerListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ToHerstellerSlice.actions
export default ToHerstellerSlice.reducer
